
  import { Component, Vue ,Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  
  import {
    productCategory,
  } from '@/api/supplier'
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:{}}) msg!:any
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private pageSize = 20
    private pageNo = 1
    private total = 0
    private choosemsg:any = this.msg

    private mounted () {
      this.gettablelist()
    }

    private returnchoosemsg(){
      // console.log(this.choosemsg)
      return this.choosemsg
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private checkchange(e,row){
      this.tablelist = this.tablelist.map(v=>{
        v.IsChoose = false
        if(v.Id==row.Id){
          v.IsChoose = true
          this.choosemsg = v
        }
        return v
      })
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private async gettablelist() {
			let params: any = {
				Skip: (this.pageNo-1)*this.pageSize,
				Take: this.pageSize,
				Keywords: this.keywords
			}
			try {
        this.tableloading = true
				const res: any = await productCategory(params);
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            if(v.Id==this.choosemsg.Id){
              v.IsChoose = true
              this.choosemsg = v
            }else{
              v.IsChoose = false
            }
            return v
          })
          this.total = res.Result.Total;
        }
			} finally{
        this.tableloading = false
      }
		}
  }
